// extracted by mini-css-extract-plugin
export default {"wrap":"face-click_wrap__pQbVg","mobileImg":"face-click_mobileImg__Zp39+","img":"face-click_img__l2k6x","dot":"face-click_dot__-H5Ex","active":"face-click_active__hdizQ"};